import { track } from "../track";

export const trackAvatarPhotoUploadScs = (params: { photo_count: number }) =>
  track({ event: "avatar_photo_upload_scs", ...params });
